<template>
  <transition name="slide-fade" mode="out-in">
    <div id="service" v-wechat-title="$route.meta.title">
      <!-- <van-nav-bar title="麻丘镇" fixed="" left-arrow @click-left="onClickLeft" /> -->
      <div class="main">
        <img src="@/assets/bg.png" class="bg" />
        <div class="villageAll">
          <div class="vill-tit">选择你要看查看的村：</div>
          <div class="vil-list flex">
            <div
              class="item"
              v-for="(item, index) in list1"
              :key="index"
              @click="toUrl(item.id, item.name)"
            >
              {{ item.name }}
              <img src="@/assets/icon4-2.png">
            </div>
          </div>
          <div class="vill-tit">选择你要看查看的社区：</div>
          <div class="vil-list flex vil-list2">
            <div
              class="item"
              v-for="(item, index) in list2"
              :key="index"
              @click="toUrl(item.id, item.name)"
            >
              {{ item.name }}
              <img src="@/assets/icon4-2.png" />
            </div>
          </div>
        </div>
        <!-- <div class="list">
          <van-loading size="20px" v-show="loading">加载中...</van-loading>

          <div
            class="list-item"
            v-for="(item, index) in list"
            :key="index"
            @click="toUrl(item.id, item.name)"
          >
            <img src="@/assets/san2.png" v-if="item.icon == ''" />
            <img :src="item.icon" v-else />
            <div>{{ item.name }}</div>
          </div>
        </div> -->
      </div>
      <!-- <div class="btn1" @click="toJu()">一键举报</div> -->
    </div>
  </transition>
</template>
<script>
import { NavBar, Loading } from "vant";
import { village } from "@/api/apiData";
import axios from "axios";
export default {
  components: {
    [NavBar.name]: NavBar,
    [Loading.name]: Loading,
  },
  data() {
    return {
      list: [],
      loading: true,
      list1:[],
      list2:[],
    };
  },
  mounted() {
    let that =this
    this.getVillage();
    axios
      .post("https://mqzpower.ncscloudmedia.com/index.php/api/village/all", {})
      .then(function (response) {
        let data = response.data.data
        that.list1 = data.slice(0,16)
        that.list2 = data.slice(16)
      })
      .catch(function (error) {
        console.log(error);
      });
  },
  methods: {
    onClickLeft() {
      this.$router.push("/index");
    },
    toUrl(id, n) {
      this.$router.push({
        path: "/news",
        query: { id: id, name: n },
      });
    },
    toJu() {
      this.$router.push({
        path: "/notice",
      });
    },
    getVillage() {
      village().then((res) => {
        this.list = res;
        this.loading = false;
      });
    },
  },
};
</script>
<style scoped>
.flex{
  display: flex;
  align-items: center;
}
.btn1 {
  width: 50%;
  margin: 0 auto;
  background: #f44336;
  color: white;
  line-height: 2.5rem;
  height: 2.5rem;
  border-radius: 5px;
  margin-bottom: 3rem;
  font-weight: bold;
  margin-top: 2rem;
}
.main .bg {
  width: 100%;
  height: 100%;
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  z-index: -1;
  /* top: 46px; */
}
/* #service{
    height: 100%;
    background: url("../assets/index-bg.png");
    background-size:100% 100% ;
} */
/* .main {
  padding-top: 5%;
} */
.list {
  display: flex;
  flex-wrap: wrap;
  /* height: 20rem;
  overflow: scroll; */
}
.list-item {
  width: 22.5%;
  /* padding: 1rem; */
  margin-left: 2%;
  margin-bottom: 4%;
}
.list-item img {
  width: 90%;
}
.list-item div {
  color: #100f0f;
  font-weight: bold;
  font-size: 0.9rem;
}
.vill-tit {
  color: #ff0000;
  background: #fbc2be;
  padding: 5px 40px;
  font-size: 15px;
  font-weight: bold;
  box-shadow: 1px 0px 7px 1px #bdbdbd;
  line-height: 2;
  text-align: left;
}
.vil-list {
  justify-content: space-between;
  padding: 20px 20px 10px;
  flex-wrap: wrap;
}
.vil-list img {
  position: absolute;
  width: 30px;
  height: 30px;
  left: -3px;
  top: 1px;
}
.vil-list .item {
  position: relative;
  width: 28%;
  text-align: center;
  border: solid 1px #ffc507;
  color: #ff0000;
  border-radius: 25px;
  font-size: 13px;
  line-height: 2.3;
  margin-bottom: 20px;
  padding-left: 5px;
  font-weight: bold;
}
.vil-list .item:nth-child(17) {
  width: 64%;
}
/* .vil-list2 .item:nth-child(1){
    width: 45%;
} */
.vil-list2 .item {
  width: 45%;
}
.vil-tit {
  width: 100%;
}
</style>


// WEBPACK FOOTER //
// src/page/service.vue